import { Cell } from './chip-heatmap';

export interface TooltipData extends Cell {}

export function ChipHeatmapTooltipContent({ d }: { d: TooltipData }) {
  const baseStyle: React.CSSProperties = { fontFamily: 'monospace' };

  // Create individual styles for each metric so we can colour and strike individually.
  const ctStyle: React.CSSProperties = { ...baseStyle };
  const tmStyle: React.CSSProperties = { ...baseStyle };
  const effStyle: React.CSSProperties = { ...baseStyle };

  // Apply rule-specific colour and strikethrough
  switch (d.rejectRule) {
    case 0: // Tm rule violation
      tmStyle.color = 'red';
      tmStyle.textDecoration = 'line-through';
      break;
    case 1: // Ct rule - red
      ctStyle.color = 'red';
      ctStyle.textDecoration = 'line-through';
      break;
    case 2: // Efficiency rule - red
      effStyle.color = 'red';
      effStyle.textDecoration = 'line-through';
      break;
    case 3: // Ct rule - orange
      ctStyle.color = 'orange';
      ctStyle.textDecoration = 'line-through';
      break;
    case 4: // Efficiency rule - orange
      effStyle.color = 'orange';
      effStyle.textDecoration = 'line-through';
      break;
    default:
      // No disqualification - keep default style
      break;
  }

  const fmt = (val: number | null) => (val == null || !Number.isFinite(val) ? '--.--' : val.toFixed(2));

  return (
    <div style={{ padding: 8 }}>
      <table style={{ width: '100%' }}>
        <tbody>
          <tr>
            <td>Sample:</td>
            <td>{d.sampleName ? `${d.sample} - ${d.sampleName}` : d.sample}</td>
          </tr>
          <tr>
            <td>Assay:</td>
            <td>{d.assay}</td>
          </tr>
          <tr>
            <td>Row,Col:</td>
            <td>
              {d.row},{d.column}
            </td>
          </tr>
          <tr>
            <td>Ct:</td>
            <td>
              <code style={ctStyle}>{fmt(d.ct)}</code>
            </td>
          </tr>
          <tr>
            <td>Tm:</td>
            <td>
              <code style={tmStyle}>{fmt(d.tm)}</code>
            </td>
          </tr>
          <tr>
            <td>Efficiency:</td>
            <td>
              <code style={effStyle}>{fmt(d.efficiency)}</code>
            </td>
          </tr>
          <tr>
            <td>Flags:</td>
            <td>{d.flags}</td>
          </tr>
          <tr>
            <td>Status:</td>
            <td>{d.rejectRule == null ? '✓ Ok' : `× Disqualified (rule ${d.rejectRule})`}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
